import { ExportBidReportResponse } from "lib/generated/app-service-gql/graphql";

export async function getBidReportPDFUrlForExternalUser(
  id: string,
  urlShareSignature: string,
): Promise<ExportBidReportResponse> {
  const response = await fetch(`${window.app_service_url}/bid-report-api/getBidReportPDFUrl`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, urlShareSignature }),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch bid report PDF URL: ${response.status} ${response.statusText}`,
    );
  }

  return (await response.json()) as ExportBidReportResponse;
}
